import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from '../../../shared/utils.service';
import { SiteModel } from '../../../models/site.model';
import { AppService } from '../../../app.service';
import { RBACService } from '../../../shared/rbac.service';

@Component({
  selector: 'app-sites-noticeboard-layout',
  templateUrl: './sites-noticeboard-layout.component.html',
  styleUrls: ['./sites-noticeboard-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SitesNoticeboardLayoutComponent implements OnInit {
  site_id: number;
  parent_site_id: number;

  isViewMode: boolean = false;

  // RBAC permission flags. Resolved once in ngOnInit() to avoid re-evaluating on every change detection cycle.
  canEditSites: boolean = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public app: AppService,
    public utils: UtilsService,
    public rbac: RBACService
  ) {}

  ngOnInit(): void {
    // Resolve RBAC permission flags before any early returns so they are always set.
    this.canEditSites = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES,
          RBACService.RBAC_A.A_EDIT
        )
      ],
      true
    );

    if (
      !this.rbac.userCanAccess([
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES,
          RBACService.RBAC_A.A_VIEW
        ),
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES,
          RBACService.RBAC_A.A_EDIT
        )
      ])
    ) {
      this.rbac.showGenericAccessDeniedMessage();
      this.router.navigate(['/sites']);
      return;
    }

    // Check if we are in view mode. Extract it from the second last segment of the url.
    const action: string = this.router.url
      .split('?')[0]
      .split('/')
      .slice(-2, -1)[0];

    this.isViewMode = action === 'view';

    // Get the site id from the route params.
    const parent_id: number = Number(
      this.route.parent.snapshot.params['parent_id']
    );
    const child_id: number = Number(
      this.route.parent.snapshot.params['child_id']
    );

    // Check if we are updating a site or creating a new one.
    if (
      child_id ||
      (typeof this.route.parent.snapshot.params['child_id'] == 'undefined' &&
        parent_id)
    ) {
      // Store the site id.
      this.site_id = child_id ? child_id : parent_id;
      // If this is a child site, store the parent site id.
      if (child_id && parent_id) {
        this.parent_site_id = parent_id;
      }
    } else {
      // Get and store the parent site id if it is present.
      if (parent_id) {
        // Store the site id.
        this.parent_site_id = parent_id;
      }
    }
  }

  protected readonly RBACService = RBACService;
}
